import { State } from '../reducers/rootReducer'
import { UiState } from '../reducers/uiReducer'

const uiSelector = (state: State): UiState => state.ui

export default uiSelector
